import { ApiConfig, ApiServiceConfig, ApiServiceCredentials } from './types'

let _config: Nullable<ApiServiceConfig> = null

function setConfigProperty<T extends keyof ApiServiceConfig>(
	key: T,
	value: ApiServiceConfig[T]
) {
	if (!_config) {
		throw new Error(
			'[ApiService] config is not set, please call `setConfig` first'
		)
	}

	_config[key] = value
}

export function setConfig(config: ApiServiceConfig) {
	_config = config
}

export function isConfigAvailable() {
	return !!_config
}

export function getConfig() {
	if (!_config) {
		throw new Error(
			'[ApiService] config is not set, please call `setConfig` first'
		)
	}

	const {
		refreshTokenApi,
		revokeTokenApi,
		downloadApi,
		uploadApi,
		apiServerDefaultVersion
	} = _config

	return {
		..._config,
		refreshTokenApi: {
			method: 'POST',
			scope: 'uaa',
			path: 'connect/token/refresh',
			version: apiServerDefaultVersion,
			...(refreshTokenApi || {})
		} as Required<ApiConfig>,
		revokeTokenApi: {
			method: 'POST',
			scope: 'uaa',
			path: 'connect/token/revoke',
			version: apiServerDefaultVersion,
			...(revokeTokenApi || {})
		} as Required<ApiConfig>,
		downloadApi: {
			method: 'GET',
			scope: 'file',
			path: 'contents/download',
			version: apiServerDefaultVersion,
			...(downloadApi || {})
		} as Required<ApiConfig>,
		uploadApi: {
			method: 'POST',
			scope: 'file',
			path: 'contents/upload',
			version: apiServerDefaultVersion,
			...(uploadApi || {})
		} as Required<ApiConfig>
	}
}

export function setCredentials(credentials: Nullable<ApiServiceCredentials>) {
	setConfigProperty('credentials', credentials)
}

export function setDeviceType(deviceType: number) {
	setConfigProperty('deviceType', deviceType)
}

export function setAppVersion(appVersion: string | number) {
	setConfigProperty('appVersion', appVersion)
}

export function setAcceptLanguage(
	acceptLanguage: ApiServiceConfig['acceptLanguage']
) {
	setConfigProperty('acceptLanguage', acceptLanguage)
}
